import config from "../../config.json";

export const AwsConfigStorage = {
  AWSS3:
    {
      bucket: config.STORAGE_BUCKET_ID,
      region: config.STORAGE_REGION
    }
};